<template>
  <div class="home">
    <posts
      :poolPreview="poolId"
      :previewSettings="{
        posts_per_chunk,
        interval,
        fontSize,
        arrangement
      }"
    />
    <!-- <chunks :poolPreview="pool" :previewSettings="{ cols, interval, fontSize, arrangement }" :colPreview="cols" :timePreview="interval" :fontSize="fontSize" /> -->
  </div>
</template>

<script>
import Posts from '@/components/Posts';

export default {
  name: 'home',
  components: {
    Posts
  },

  computed: {
    poolId() {
      return this.$route.params.id
        ? parseInt(this.$route.params.id, 10)
        : false;
    },

    posts_per_chunk() {
      return this.$route.params.count
        ? parseInt(this.$route.params.count, 10)
        : undefined;
    },

    interval() {
      return this.$route.params.interval
        ? parseInt(this.$route.params.interval, 10)
        : undefined;
    },

    fontSize() {
      return this.$route.params.font_size
        ? this.$route.params.font_size
        : undefined;
    },

    arrangement() {
      return this.$route.params.arrangement
        ? this.$route.params.arrangement
        : undefined;
    },

    show_images() {
      return this.$route.params.show_images
        ? this.$route.params.show_images === 'true'
        : undefined;
    },

    crop_images() {
      return this.$route.params.crop_images
        ? this.$route.params.crop_images === 'true'
        : undefined;
    }
  }
};
</script>
